<template>
<div class="view-edit-page">
    WHAA {{ this.guid }}
    <v-navigation-drawer
    app
      clipped
      right
      fixed
      v-model="contextDrawer"
      hide-overlay
      disable-resize-watcher
      :permanent="false"
      :temporary="false"
    >
      <v-list dense>
        <v-list-tile @click.native="contextDrawer = !contextDrawer">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Selected Page View Drawer</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

</div>
</template>



<script>
export default {
    data () {
        return {
            contextDrawer: true
        }
    },
    props: {
      'guid': null
    },
}
</script>

<style>

</style>
